import classNames from "utils/class-names";
import { FILTER_TYPE } from "utils/constants";

export const COLUMNS_DATA = ({
  deleteRow,
  editRow,
  isSuperFranchise,
  isFranchiseEmployee,
  isSubFranchise,
  filters,
}) => [
  {
    Header: "S.No",
    accessor: "_index",
    disableSortBy: true,
  },
  {
    Header: "Doctor Name",
    accessor: "doctor_obj.doctor_name",
    disableSortBy: true,
  },
  {
    Header: "Clinic Name",
    accessor: "clinic_obj.clinic_name",
    disableSortBy: true,
  },
  {
    Header: "Clinic Address",
    accessor: "clinic_obj.clinic_address",
    disableSortBy: true,
  },
  {
    Header: "Zone",
    accessor: "zone_obj.zone_name",
    disableSortBy: true,
  },
  {
    Header: "OPD Fee",
    accessor: "opd_fee",
    disableSortBy: true,
  },
  {
    Header: "Valid From",
    accessor: "valid_from",
    disableSortBy: true,
  },
  {
    Header: "Valid Till",
    accessor: "valid_till",
    disableSortBy: true,
  },
  {
    Header: "Created By",
    accessor: "created_by_name",
    disableSortBy: true,
  },
  {
    Header: "",
    accessor: "id",
    disableSortBy: true,
    Cell: ({ cell }) => {
      return (
        <>
          <button
            disabled={!filters.is_active}
            className={classNames("btn dropdown-toggle", {
              "btn-primary": filters.is_active,
              "btn-secondary": !filters.is_active,
            })}
            type="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            More...
          </button>
          <ul className="dropdown-menu">
            <li>
              <button
                className="dropdown-item"
                onClick={() => editRow(cell.row.original)}
              >
                Edit
              </button>
            </li>

            {isSuperFranchise != 1 &&
              isFranchiseEmployee != 1 &&
              isSubFranchise != 1 && (
                <li>
                  <button
                    className="dropdown-item"
                    onClick={() => deleteRow(cell.row.original)}
                  >
                    Delete
                  </button>
                </li>
              )}
          </ul>
        </>
      );
    },
  },
];

export const DOCTOR_OPD_CHARGE_ROUTER_FORM_CONFIG = (rowData) => [
  {
    label: "Doctor",
    type: "select",
    name: "refer_doctor_name",
    defaultValue: rowData?.doctor_id || "",
    validations: {
      maxLength: 255,
      required: true,
    },
  },
  {
    label: "Clinic",
    type: "select",
    name: "clinic_id",
    defaultValue: rowData?.clinic_id || "",
    validations: {
      maxLength: 255,
      required: true,
    },
  },
  {
    label: "OPD Fee",
    type: "input-number",
    name: "opd_fee",
    defaultValue: rowData?.opd_fee || "",
    validations: {
      maxLength: 255,
      required: true,
    },
  },
  {
    label: "Valid From",
    type: "input-date",
    name: "valid_from",
    defaultValue: rowData?.valid_from || "",
    validations: {
      maxLength: 255,
      required: true,
    },
  },
  {
    label: "Valid Till",
    type: "input-date",
    name: "valid_till",
    defaultValue: rowData?.valid_till || "",
    validations: {
      maxLength: 255,
      required: true,
    },
  },
];

export const OPTIONS = [
  { key: "clinic_name", value: "Clinic Name" },
  { key: "clinic_address", value: "Clinic Address" },
];

export const STATUS_OPTIONS = [
  { key: true, value: "Active" },
  { key: false, value: "In-Active" },
];

export const FILTER_DEFINATIONS = [
  {
    name: "keyword",
    type: FILTER_TYPE.SELECT,
    initialValue: OPTIONS[0].key,
  },
  {
    name: "text",
    type: FILTER_TYPE.TEXT,
    initialValue: "",
    debounce: true,
  },
  {
    name: "is_active",
    type: FILTER_TYPE.SELECT,
    initialValue: STATUS_OPTIONS[0].key,
  },
];
